import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Product from '../Product/Product';
import sliderimg2 from '../../Assets/images/white-hoody-sweatshirt-mockup_1409-3758-removebg-preview.png'
// import sliderimg1 from '../../Assets/images/slider-image-3.jpeg'
import sliderimg3 from '../../Assets/images/beautiful-gaming-headphone-isolated-transparent-background_191095-12526-removebg-preview.png'

import Slider from 'react-slick';
import CategorySlider from '../CategorySlider';
import Pagination from "react-js-pagination";

export default function Home() {
  const [activePage, setActivePage] = useState(1)
  const [Products, setProducts] = useState([])
  const [results, setResults] = useState(1)
  const [metadata, setMetadata] = useState({})

  const [Isloading, setIsloading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('');
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,

  };
  function handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    setActivePage(pageNumber)
    GetAllProducts(pageNumber)
  }
  async function GetAllProducts(pageNumber) {
    setIsloading(true);
    let { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/products?page=' + pageNumber);
    setProducts(data.data);
    setResults(data.results)
    setMetadata(data.metadata)
  }
  useEffect(() => {
    GetAllProducts(1);
  }, []);

  const filteredProducts = Products.filter(product =>
    product.title.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return <>
    <header className='py-5 header' >

      <div className="row g-5 align-items-center h-100 header-row mx-2">
        <div className="col-md-12 ">
          <Slider {...settings}>
            <div>
              <div className="container">
                <div className="row align-items-center h-100 ">
                  <div className="col-md-6 text-white">
                    <h1>Your destination for endless shopping possibilities </h1>
                    <p>Simplify your shopping journey with our e-commerce website's hassle-free online experience.

                      Intuitive navigation and a streamlined checkout process make every purchase a breeze.</p>
                    <button className='btn order-now px-4 py-2'>ORDER NOW  <i className="fa-solid fa-arrow-right px-2"></i></button>
                  </div>
                  <div className="col-md-6 ">
                    <img src={sliderimg2} className='w-100' />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="container">
                <div className="row align-items-center h-100">
                  <div className="col-md-6 text-white">
                    <h1>SPECIAL  <br />COLLECTION  2024</h1>
                    <p>Endless shopping possibilities await at our e-commerce website. Discover the perfect item, every time, with our unparalleled selection across countless categories.

                      Whether you're searching for the latest tech gadgets, fashion must-haves, or home decor essentials, our diverse product range has it all.

                      Experience the convenience of a true one-stop-shop, where you can find everything you need with just a few clicks.</p>
                    <button className='btn order-now px-4 py-2'>ORDER NOW  <i className="fa-solid fa-arrow-right px-2"></i> </button>
                  </div>
                  <div className="col-md-6 ">
                    <img src={sliderimg3} className='w-100' />
                  </div>
                </div>
              </div>
            </div>
          </Slider>

        </div>
      </div>
    </header>
    <div className="container">
      <div className='pt-5 my-5'>
        <div className="col mb-5"> <h1 className='titles'>Products Categories</h1></div>
        <CategorySlider />
      </div>
      <div>
        <div className='row pt-5'>
          <div className="col mb-5"> <h1 className='titles'>Products </h1></div>

          <div className='row pt-5 justify-content-center'>
            <input
              className='form-control search-input my-5 w-75'
              placeholder='Search ...'
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
          {filteredProducts?.map((product, index) => {
            return (
              <div key={index} className='col-md-3'>
                <Product product={product} />
              </div>
            );
          })}
        </div>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={metadata.limit}
          totalItemsCount={results}
          pageRangeDisplayed={5}
          linkClassName="pagination-link"
          onChange={handlePageChange}
        />
      </div>
    </div>
  </>
}

